import { useContext } from "react"
import { LangContext, Languages } from "../../../provider"

export const useLang = () => {
  const lang = useContext(LangContext).lang
  return lang as Languages
}
